import { forwardRef, type HTMLAttributes } from 'react';
import { classNames } from '~/utils/styles';

export const Divider = forwardRef<HTMLHRElement, HTMLAttributes<HTMLHRElement>>(({ className }, forwardedRef) => {
  return <hr className={classNames('mx-auto w-[90%] py-1 text-neutral-200', className)} ref={forwardedRef} />;
});
